<ng-container *ngIf="wizard">
    <div class="header">
        <div class="title sub-header">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.TITLE' | translate}}</div>
        <shared-stepper-component [steps]="wizard.steps" [currentStep]="wizard.step"></shared-stepper-component>
    </div>

    <div #scrollContainer class="desplegable">
        <div class="dummy"></div>
        <shared-route-acquire-wizard-selectpartner *ngIf="wizard.step == 1" [(wizard)]="wizard"
            (partnerSelected)="onPartnerSelected()">
        </shared-route-acquire-wizard-selectpartner>
        <shared-route-acquire-wizard-selectroute *ngIf="wizard.step == 2" [(wizard)]="wizard">
        </shared-route-acquire-wizard-selectroute>
        <shared-route-acquire-wizard-resum *ngIf="wizard.step == 3" [(wizard)]="wizard">
        </shared-route-acquire-wizard-resum>
    </div>

    <div class="zoneButtons">
        <button class="slim displacement buttonPrevious" *ngIf="wizard.step==2 || wizard.step==3"
            (click)="onPrevious()"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{
            'SHARED.ROUTE.ACQUIRE.WIZARD.PREVIOUSBUTTON.CAPTION' |
            translate }}</button>
        <button class="slim displacement buttonNext" *ngIf="wizard.step==1 || wizard.step==2"
            [disabled]="wizard.invalid" (click)="onNext()">{{
            'SHARED.ROUTE.ACQUIRE.WIZARD.NEXTBUTTON.CAPTION' |
            translate }}</button>
        <button class="slim displacement add buttonFinish" *ngIf="wizard.step==3" [disabled]="wizard.invalid"
            (click)="onFinish()">{{
            'SHARED.ROUTE.ACQUIRE.WIZARD.FINISHBUTTON.CAPTION' |
            translate }}</button>
    </div>

</ng-container>